<script setup lang="ts">
import { AvailablePaymentMethods } from '@/Pejer/types/checkout'
import { ChevronRight } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import { cn } from 'pejer/src/lib/utils'
import { computed, FunctionalComponent } from 'vue'

const props = defineProps<{
  icon?: FunctionalComponent<any>
  paymentMethod?: AvailablePaymentMethods
  // isLoading: boolean
}>()

defineEmits<{
  onClick: (event: MouseEvent) => void
}>()

const currentColorClasses = computed(() => {
  switch (props.paymentMethod) {
    case AvailablePaymentMethods.CreditCard:
      return {
        primary: 'bg-card-primary',
        accent: 'bg-card-accent',
        hover: 'hover:bg-card-accent',
        fill: 'fill-card-primary',
      }
    case AvailablePaymentMethods.Invoice:
      return {
        primary: 'bg-invoice-primary',
        accent: 'bg-invoice-accent',
        hover: 'hover:bg-invoice-accent',
        fill: 'fill-invoice-primary',
      }
    case AvailablePaymentMethods.Bank2Bank:
      return {
        primary: 'bg-green-100',
        accent: 'bg-green-300',
        hover: 'hover:bg-green-200',
        fill: 'fill-green-100',
      }
    case AvailablePaymentMethods.Vipps:
      return {
        primary: 'bg-[#FF5B24]',
        accent: 'bg-[#FF5B24]',
        hover: 'hover:bg-orange-600',
        fill: 'fill-[#FF5B24]',
      }
    default:
      return {
        primary: 'bg-card-primary',
        accent: 'bg-card-accent',
        hover: 'hover:bg-card-accent',
        fill: 'fill-card-primary',
      }
  }
})
</script>
<template>
  <Button
    :class="
      cn(
        'transition-all duration-200 ease-in-out grid grid-cols-3 items-center justify-between gap-6 group text-base font-bold shadow-sm hover:shadow-md p-1 h-[50px] rounded-sm text-white relative',
        currentColorClasses.primary,
        currentColorClasses.hover
      )
    "
    @click="$emit('onClick')"
  >
    <slot name="asChild">
      <!-- v-if="!isLoading" -->
      <div class="relative group text-white flex justify-end col-span-1">
        <component v-if="icon" :is="icon" :size="24" class="opacity-0" fill="#ffff00" />
        <component
          v-if="icon"
          :is="icon"
          :size="24"
          :class="
            cn(
              'absolute top-0 right-0 rotate-0 group-hover:top-0.5 group-hover:right-2 group-hover:scale-110 group-hover:-rotate-12 transition-all duration-400 ease-in-out',
              currentColorClasses.fill
            )
          "
        />
        <component
          v-if="icon"
          :is="icon"
          :size="24"
          :class="
            cn(
              'absolute top-0 right-0 rotate-0 group-hover:top-0.5 group-hover:-right-2 group-hover:scale-110 group-hover:rotate-12 transition-all duration-400 ease-in-out',
              currentColorClasses.fill
            )
          "
        />
        <component
          v-if="icon"
          :is="icon"
          :size="24"
          :class="
            cn(
              'absolute top-0 right-0 rotate-0 z-40 transition-all duration-400 ease-in-out group-hover:scale-125',
              currentColorClasses.fill
            )
          "
        />
      </div>
      <span class="select-none col-span-2 text-left flex justify-between items-center"
        ><slot />
        <div>
          <ChevronRight
            class="group-hover:translate-x-1 mr-2 transition-all ease-in-out duration-400 group-hover:opacity-100 opacity-0 font-bold"
            :size="24"
          /></div
      ></span>
    </slot>
  </Button>
  <!-- <Skeleton v-if="isLoading" class="h-[50px] w-full" /> -->
</template>
